{
  "title": "Portafolio",
  "subtitle": "{projects} tableros en {departments} de {total} equipos",
  "subtitle_ws": "Supervisión de {team}",
  "scope_note": "Solo tareas de tableros; no incluye tareas personales.",
  "tabs": {
    "tasks": "Tareas",
    "health": "Salud por tablero"
  },
  "quick_filters": {
    "label": "Accesos rápidos de completadas",
    "today": "Completadas hoy",
    "this_week": "Completadas esta semana",
    "this_month": "Completadas este mes"
  },
  "tiles": {
    "group_open": "Sobre lo abierto",
    "group_closed": "Sobre lo cerrado",
    "open": "Abiertas",
    "overdue": "Atrasadas",
    "no_due_date": "Sin fecha",
    "unassigned": "Sin asignar",
    "no_evidence": "Cerradas sin evidencia",
    "quick_close": "Cerradas al instante",
    "of_open": "de {n} abiertas",
    "open_now": "abiertas ahora",
    "not_applicable_closed_period": "No aplica a un periodo de cierre"
  },
  "filters": {
    "department": "Equipo",
    "project": "Tablero",
    "assignee": "Persona",
    "status": "Estado",
    "period": "Periodo",
    "period_field": {
      "due": "Vence",
      "completed": "Cerrada",
      "created": "Creada"
    },
    "presets": {
      "today": "Hoy",
      "this_week": "Esta semana",
      "this_month": "Este mes",
      "last_month": "Mes pasado",
      "custom": "Personalizado"
    },
    "period_from": "Desde",
    "period_to": "Hasta",
    "period_clear": "Quitar periodo",
    "period_chip": "{field}: {range}",
    "period_scope": "Periodo: {label}",
    "period_all": "Todos",
    "search": "Buscar tarea…",
    "flags": "Señales",
    "group_by": "Agrupar por",
    "sort": "Ordenar por",
    "clear": "Limpiar filtros",
    "none_department": "Sin equipo",
    "none_assignee": "Sin asignar",
    "all": "Todos",
    "n_selected": "{n} seleccionado | {n} seleccionados",
    "count": {
      "departments": "{n} equipo | {n} equipos",
      "projects": "{n} tablero | {n} tableros",
      "members": "{n} persona | {n} personas"
    },
    "direction_asc": "Orden ascendente",
    "direction_desc": "Orden descendente",
    "button": "Filtros | Filtros ({n}) | Filtros ({n})",
    "sheet_title": "Filtros",
    "apply": "Aplicar ({n} tarea) | Aplicar ({n} tareas)",
    "none_project": "Sin tablero"
  },
  "group_by": {
    "department": "Equipo",
    "project": "Tablero",
    "assignee": "Persona"
  },
  "sort": {
    "due_date": "Vencimiento",
    "created_at": "Creación",
    "updated_at": "Última actividad",
    "priority": "Prioridad"
  },
  "status": {
    "open": "Abierta",
    "in_progress": "En progreso",
    "done": "Completada",
    "cancelled": "Cancelada"
  },
  "flags": {
    "closed_only_hint": "Solo aplica a tareas completadas; al activarla se filtra por Completada.",
    "overdue": {
      "label": "Atrasada",
      "hint": "Tarea abierta con fecha de vencimiento pasada."
    },
    "no_due_date": {
      "label": "Sin fecha",
      "hint": "Tarea abierta sin fecha de vencimiento."
    },
    "unassigned": {
      "label": "Sin asignar",
      "hint": "Nadie tiene asignada esta tarea."
    },
    "no_description": {
      "label": "Sin descripción",
      "hint": "La tarea no explica qué hay que hacer."
    },
    "stale": {
      "label": "Sin actividad",
      "hint": "Sin cambios en los últimos 14 días."
    },
    "quick_close": {
      "label": "Cierre al instante",
      "hint": "Se completó menos de 2 minutos después de crearse: registro de trabajo ya hecho, no una tarea gestionada."
    },
    "no_evidence": {
      "label": "Sin evidencia",
      "hint": "Se completó sin ningún comentario ni adjunto."
    }
  },
  "table": {
    "task": "Tarea",
    "project": "Tablero",
    "assignee": "Responsable",
    "due": "Vence",
    "closed_at": "Cerrada",
    "status": "Estado",
    "signals": "Señales",
    "no_due_date": "Sin fecha",
    "load_more": "Cargar más",
    "group_none_department": "Sin equipo",
    "group_none_assignee": "Sin asignar",
    "count": "{n} tarea | {n} tareas",
    "group_count": "{loaded} de {total}",
    "showing": "Mostrando {shown} de {total}",
    "matching": "{n} tarea coincide con: | {n} tareas coinciden con:",
    "remove_filter": "Quitar el filtro {name}",
    "no_longer_matches": "Ya no coincide",
    "due_on": "Vence {date}",
    "closed_on": "Cerrada {date}",
    "group_none_project": "Sin tablero (personales)",
    "no_project": "Personal (sin tablero)"
  },
  "health": {
    "score": "Calidad {score}/100",
    "score_none": "Sin datos",
    "badge": {
      "green": "Saludable",
      "amber_quality": "Atención · calidad {score}",
      "amber_overdue": "Atención · {overdue} de {open} atrasadas",
      "red_quality": "Crítico · calidad {score}",
      "red_overdue": "Crítico · {overdue} de {open} atrasadas"
    },
    "sort": {
      "label": "Ordenar por",
      "worst": "Peor calidad primero",
      "most_overdue": "Más atrasadas",
      "name": "Por equipo y tablero"
    },
    "attention": "{n} tablero necesita atención | {n} tableros necesitan atención",
    "no_data_line": "{n} sin actividad: {names}",
    "metrics": {
      "open": "Abiertas",
      "overdue": "Atrasadas",
      "no_due_date_open": "Sin fecha",
      "unassigned_open": "Sin asignar",
      "done_30d": "Cerradas 30d",
      "quick_close_30d": "Al instante 30d",
      "no_evidence_30d": "Sin evidencia 30d"
    },
    "last_activity": "Última actividad {when}",
    "no_activity": "Sin actividad",
    "legend": "La calidad combina cuántas tareas abiertas tienen fecha y persona asignada, y cuántas cerradas en 30 días dejaron evidencia (comentario o adjunto)."
  },
  "empty": {
    "no_tasks_title": "Aún no hay tareas en los tableros",
    "no_tasks_body": "Cuando los equipos creen tareas en sus tableros, aparecerán aquí.",
    "no_match_title": "Ninguna tarea coincide",
    "no_match_body": "Prueba con otros filtros o límpialos."
  },
  "forbidden": {
    "title": "Solo para administradores",
    "body": "El Portafolio lo pueden ver los administradores del workspace."
  },
  "error": "No se pudo cargar el Portafolio.",
  "rate_limited": "Demasiadas solicitudes seguidas. Reintentando en {s} s…",
  "locked": {
    "title": "Supervisa todos los equipos desde un solo lugar",
    "body": "Con el plan Business ves todas las tareas de todos los tableros, con señales de calidad y salud por tablero."
  },
  "report": {
    "button": "Informe PDF",
    "title": "Informe de Portafolio",
    "subtitle": "Se genera con los filtros que tienes aplicados ahora mismo. Si cambias los filtros, vuelve a abrir este cuadro.",
    "scope_label": "Alcance",
    "scope_all": "Todas las fechas",
    "tasks_count": "Sin tareas | {n} tarea | {n} tareas",
    "group_by": "Agrupado por {group}",
    "ai_title": "Análisis ejecutivo (IA)",
    "ai_hint": "Opcional: genera un análisis del conjunto filtrado con IA y se incluirá en el PDF.",
    "generate_ai": "Generar análisis",
    "regenerate_ai": "Volver a generar",
    "generating": "Analizando el portafolio…",
    "download": "Descargar PDF",
    "downloading": "Generando PDF…",
    "error_ai": "No se pudo generar el análisis. Inténtalo de nuevo.",
    "error_pdf": "No se pudo generar el PDF. Inténtalo de nuevo.",
    "empty_hint": "Ninguna tarea cumple los filtros; el informe saldrá vacío."
  }
}
